import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated } from '../store/selectors/AuthSelectors';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children, permissions, requireAll = false }) => {
  const isAuth = useSelector(isAuthenticated);
  const location = useLocation();

  // Retrieve user permissions from localStorage
  const userDetails = JSON.parse(localStorage.getItem('userDetails'));
  const userPermissions = userDetails?.roleDetails?.permissions || [];

  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Permission Check Logic
  if (permissions) {
    const requiredPermissions = Array.isArray(permissions) ? permissions : [permissions];

    if (requiredPermissions.length > 0) {
      const hasPermission = requireAll
        ? requiredPermissions.every(p => userPermissions.includes(p))
        : requiredPermissions.some(p => userPermissions.includes(p));

      if (!hasPermission) {
        return <Navigate to="/unauthorized" replace />;
      }
    }
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node,
  permissions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  requireAll: PropTypes.bool
};

export default ProtectedRoute; 